import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class UserVarifyService {
    constructor(
        private httpService: HttpService) { }

    //查询可否提现
    //chen 2017-01-04
    getCashEnable() {
        let url = AppConfig.GetProdUrl() + "/Index/QueryCashEnable";
        return this.httpService.get(url);
    }

    //查询剩余提现次数
    //chen 2017-01-04
    getCashTime() {
        let url = AppConfig.GetProdUrl() + "/Index/RemainCashTime";
        return this.httpService.get(url);
    }

    //提交提现申请
    //chen 2017-01-04
    getDrawMoney(moneyPwd: string, money: string, bankId: Number) {
        let param = "moneyPwd=" + moneyPwd + "&money=" + money + "&bankId=" + bankId;
        let url = AppConfig.GetProdUrl() + "/Index/WithDrawMoney";
        return this.httpService.get(url + "?" + param);
    }

    //查询用户余额
    //chen 2017-01-04
    getUserMoney() {
        let url = AppConfig.GetProdUrl() + "/User/GetUserMoney";
        return this.httpService.get(url);
    }

    //用户最后登录信息
    //TQQ 2017-05-05
    getUserLastLogin() {
        let url = AppConfig.GetProdUrl() + "/User/GetUserLastLogin";
        return this.httpService.get(url);
    }

    //用户的登录信息
    getLoginLog() {
        let url = AppConfig.GetProdUrl() + "/User/UserLogs";
        // let par = "endDate=" + param.endDate + "&pageIndex=" + param.pageIndex + "&pageSize=" + param.pageSize + "&startDate=" + param.startDate + "&userName=" + param.userName;
        let par = "pageIndex=1&pageSize=50";
        return this.httpService.get(url + "?" + par);
    }
    //获取用户的消费金额
    getTodayConsumMoney() {
        let url = AppConfig.GetProdUrl() + "/User/GetTodayConsumMoney";
        return this.httpService.get(url);
    }

    //修改登录密码
    //TQQ 2017-05-05
    updatePwd(param) {
        var url = AppConfig.GetProdUrl() + "/User/Pwd";
        return this.httpService.post(url, param);
    }

    //获取用户银行信息
    //TQQ 2017-05-02
    getUserBanks() {
        let param = "pageIndex=" + 1 + "&pageSize=" + 100;
        let url = AppConfig.GetProdUrl() + "/User/GetUserBanks";
        return this.httpService.get(url + "?" + param);
    }

    //设为默认银行
    //TQQ 2017-05-02
    setDefaultBank(bankid) {
        let param = "id=" + bankid;
        let url = AppConfig.GetProdUrl() + "/User/SetDefaultCard";
        return this.httpService.get(url + "?" + param);
    }

    //查询可提现的银行列表
    //TQQ 2017-05-02
    queryDrawBanks() {
        let url = AppConfig.GetProdUrl() + "/User/QueryDrawBanks";
        return this.httpService.get(url);
    }

    //省列表
    //TQQ 2017-05-02
    proList() {
        let url = AppConfig.GetProdUrl() + "/User/ProList";
        return this.httpService.get(url);
    }

    //市列表
    //TQQ 2017-05-02
    cityList(procode: string) {
        let url = AppConfig.GetProdUrl() + "/User/CityList?proCode=" + procode;
        return this.httpService.get(url);
    }

    //区列表
    //TQQ 2017-05-02
    areaList(cityCode: string) {
        let url = AppConfig.GetProdUrl() + "/User/AreaList?cityCode=" + cityCode;
        return this.httpService.get(url);
    }

    //添加银行卡 
    //TQQ 2017-05-02
    addUserBank(bank) {
        let url = AppConfig.GetProdUrl() + "/User/AddUserBank";
        return this.httpService.post(url, bank);
    }

    //判断是否已设置资金密码
    //TQQ 2017-05-02
    checkBankPassword(params) {
        let url = AppConfig.GetProdUrl() + "/User/CheckBankPassword";
        return this.httpService.post(url, null);
    }

    //修改资金密码
    //TQQ 2017-05-02
    updateBankPwd(bankpwd) {
        let url = AppConfig.GetProdUrl() + "/User/Funds";
        return this.httpService.post(url, bankpwd);
    }

    //添加资金密码
    //TQQ 2017-05-02
    addBankPwd(bankpwd) {
        let url = AppConfig.GetProdUrl() + "/User/CreateBankPassword";
        return this.httpService.post(url, bankpwd);
    }

    //验证资金密码是否正确
    //TQQ 2017-06-01
    ckBankPassword(params) {
        let url = AppConfig.GetProdUrl() + "/User/CheckBankPassword";
        return this.httpService.post(url, params);
    }
    // http://172.16.44.79:1001/api/User/CheckBankPassword?pwd=a123456&chkSign=1

    //获取密保问题
    //TQQ 2017-05-03
    getSecurityInfo() {
        let url = AppConfig.GetProdUrl() + "/User/GetSecurityQuestions";
        return this.httpService.get(url);
    }

    //判断是否设置密保
    //TQQ 2017-05-03
    ckkUserSecurityQuestion() {
        let url = AppConfig.GetProdUrl() + "/User/CheckUserSecurityQuestion";
        return this.httpService.get(url);
    }

    //设置密保
    //TQQ 2017-05-03
    setSecurityInfo(question) {
        let url = AppConfig.GetProdUrl() + "/User/SetUserSecurityInfo";
        return this.httpService.post(url, question);
    }

    //验证密保是否正确
    //TQQ 2017-05-03
    ckUserQuestion(question) {
        let url = AppConfig.GetProdUrl() + "/Log/CkUserQuestion";
        return this.httpService.post(url, question);
    }

    //获取密保问及答案
    //TQQ 2017-05-03
    getMiBaoQuestion(name) {
        let url = AppConfig.GetProdUrl() + "/Log/forgetPwdck";
        return this.httpService.post(url, name);
    }

    //判断是否有银行卡，有则返回持卡人姓名
    //TQQ 2017-05-17
    getUserBankUserName() {
        let url = AppConfig.GetProdUrl() + "/User/GetUserBankUserName";
        return this.httpService.get(url);
    }

    //获取谷歌登录器二维码
    //TQQ 2017-05-11
    getGaSecret() {
        let url = AppConfig.GetProdUrl() + "/User/GetGaSecret";
        return this.httpService.get(url);
    }
    //获取谷歌登录器二维码
    getQrCodeImg() {
        let url = AppConfig.GetProdUrl() + "/auth/QrCodeImg";
        return this.httpService.get(url);
    }
    //添加谷歌登录器
    //TQQ 2017-05-11
    addGasecret(params) {
        let url = AppConfig.GetProdUrl() + "/User/AddGasecret";
        return this.httpService.get(url, params);
    }

    //检测用户名是否存在
    //TQQ 2017-05-15
    checkUserName(params) {
        let url = AppConfig.GetProdUrl() + "/User/CheckUserName";
        return this.httpService.get(url, params);
    }

    //注册用户
    //TQQ 2017-05-15
    registerUser(params) {
        let url = AppConfig.GetProdUrl() + "/User/RegisterUserByKey";
        return this.httpService.get(url, params);
    }

    //获取未读消息的数量
    //TQQ 2017-05-22
    getCurrUserUnReadCount() {
        let url = AppConfig.GetProdUrl() + '/User/GetCurrUserUnReadCount';
        return this.httpService.get(url);
    }
    //根据键读取配置信息
    GetSettings() {
        let Params = 'key=Legend.Configuration.PrivateReturnSetting'
        let url = AppConfig.GetProdUrl() + '/User/GetSettings?' + Params;
        return this.httpService.get(url);
    }
    //获取谷歌验证器下载地址
    GetGoogleUrl() {
        let url = AppConfig.GetProdUrl() + '/System/GetGoogleUrlSetting';
        return this.httpService.get(url);
    }
    //获取银行卡logo图片线上地址
    GetBankLogoUrl() {
        let url = AppConfig.GetProdUrl() + '/User/GetBankImgSetting';
        return this.httpService.get(url);
    }
}




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/userVarify.service.ts